import { render } from "./DashboardCreateTop.vue?vue&type=template&id=6c3e8286&scoped=true"
import script from "./DashboardCreateTop.vue?vue&type=script&lang=js"
export * from "./DashboardCreateTop.vue?vue&type=script&lang=js"

import "./DashboardCreateTop.vue?vue&type=style&index=0&id=6c3e8286&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3e8286"]])

export default __exports__